export const ORG_SECTIONS = [
  {
    title: "DIMENSIONE FISICA — CAPACITÀ OPERATIVA",
    questions: [
      "I processi critici sono strutturati e ripetibili, non dipendenti da persone specifiche",
      "Le risorse (tempo, budget, competenze) sono allineate con gli obiettivi di crescita dichiarati",
      "L'organizzazione può assorbire un aumento significativo del carico senza andare in affanno",
      "Esistono sistemi (non solo persone) che garantiscono continuità operativa",
    ],
  },
  {
    title: "DIMENSIONE MENTALE — CHIAREZZA STRATEGICA",
    questions: [
      "Le priorità dei prossimi 12 mesi sono chiare e condivise a tutti i livelli manageriali",
      "È chiaro dove investire e dove non investire",
      "Le decisioni strategiche si traducono in obiettivi misurabili (KPI)",
      "Il management rivede regolarmente le priorità, invece di lasciarle immutate per inerzia",
    ],
  },
  {
    title: "DIMENSIONE EMOTIVA — PRONTEZZA AL CAMBIAMENTO",
    questions: [
      "Il management percepisce il cambiamento come opportunità più che come minaccia",
      "Le persone chiave sono coinvolte nella visione, non solo esecutrici",
      "L'azienda ha già affrontato con successo cambiamenti significativi in passato",
      "Esiste apertura reale a mettere in discussione modi di lavorare consolidati",
    ],
  },
  {
    title: "DIMENSIONE RELAZIONALE — RESPONSABILITÀ E GOVERNANCE",
    questions: [
      "Le responsabilità decisionali sono distribuite, non concentrate su una sola persona",
      "Esiste una seconda linea manageriale con reale autonomia operativa",
      "Le decisioni vengono prese con la velocità che il mercato richiede",
      "La comunicazione tra funzioni (commerciale, operations, HR...) è fluida",
    ],
  },
  {
    title: "DIMENSIONE SPIRITUALE — PURPOSE E VISIONE",
    questions: [
      "Esiste un purpose aziendale chiaro che guida le decisioni quotidiane, non solo dichiarazioni di facciata",
      "Le persone sanno spiegare perché fanno quello che fanno, oltre al \"cosa\"",
      "La cultura aziendale è coerente con i valori dichiarati",
      "Il purpose attrae e trattiene i talenti",
    ],
  },
];

// flatten to 20 questions with section metadata
export const ORG_QUESTIONS = ORG_SECTIONS.flatMap((sec, si) =>
  sec.questions.map((text, qi) => ({
    id: `q${si * 4 + qi + 1}`,
    number: si * 4 + qi + 1,
    sectionTitle: sec.title,
    sectionIndex: si,
    isSectionStart: qi === 0,
    text,
  }))
);

export const ORG_SCALE = [
  { value: 1, label: "Molto marginale" },
  { value: 2, label: "" },
  { value: 3, label: "" },
  { value: 4, label: "" },
  { value: 5, label: "Molto solido" },
];

export const ORG_RESULTS = {
  reattiva: {
    range: "20 – 46",
    title: "Azienda in Modalità Reattiva",
    body: "L'organizzazione è operativa ma priva di una governance strutturata: molte decisioni dipendono ancora troppo da una singola persona, e la crescita rischia di essere frenata più dalla struttura che dal mercato.",
    advice: "Il percorso Strategic Change è il punto di partenza più efficace per costruire le fondamenta di una crescita sostenibile.",
  },
  transizione: {
    range: "47 – 73",
    title: "Azienda in Transizione",
    body: "Alcuni pilastri sono solidi, ma c'è incoerenza tra le dimensioni — energia dispersa tra iniziative che non si sommano tra loro.",
    advice: "Un intervento mirato su People & HR o Sviluppo Organizzativo può allineare le parti e liberare il potenziale già presente.",
  },
  orchestrata: {
    range: "74 – 100",
    title: "Azienda Orchestrata",
    body: "Equilibrio reale tra le cinque dimensioni: l'organizzazione è pronta per la fase successiva, che sia crescita accelerata, passaggio generazionale o preparazione a un'operazione straordinaria.",
    advice: "Sei nella posizione ideale per un percorso di Executive Advisory per massimizzare il valore costruito.",
  },
};

export const EMPLOYEE_OPTIONS = ["1-10", "11-50", "51-250", "250+"];

export const PRIVACY_URL = "https://www.iubenda.com/privacy-policy/40825306";
